import Registrationfee from "../Components/Registraionfee"
import Footer from "../Components/Footer"
import Navbar from "../Components/Navbar"

const RegistrationFeePage = () => {
  return (
    <div className="contact-page">
      <Navbar />
      <Registrationfee />
      <Footer />
    </div>
  );
};

export default RegistrationFeePage;
